<script lang="ts">
	interface Props {
		id?: string;
		color?: string;
		width?: number;
		height?: number;
	}

	let {
		id = 'circle-background',
		color = 'text-white',
		width = 558,
		height = 558
	}: Props = $props();
</script>

<svg
	viewBox="0 0 558 558"
	{width}
	{height}
	fill="none"
	aria-hidden="true"
	class="animate-spin-slower"
>
	<defs>
		<linearGradient {id} x1="79" y1="16" x2="105" y2="237" gradientUnits="userSpaceOnUse">
			<stop stop-color="#FC355C" />
			<stop offset="1" stop-color="#FC355C" stop-opacity="0" />
		</linearGradient>
	</defs>
	<path
		opacity=".2"
		d="M1 279C1 125.465 125.465 1 279 1s278 124.465 278 278-124.465 278-278 278S1 432.535 1 279Z"
		stroke={color}
	/>
	<path d="M1 279C1 125.465 125.465 1 279 1" stroke={`url(#${id})`} stroke-linecap="round" />
</svg>
